import Vue from 'vue'

Vue.mixin({
	methods: {
		getQueryVariable: function (variable) {
			let query = window.location.search.substring(1);
			let vars = query.split("&");
			for (let i = 0; i < vars.length; i++) {
				let pair = vars[i].split("=");
				if (pair[0] == variable) {
					return pair[1];
				}
			}
			return (false);
		},
		pushToArray: function (arr, obj, prop) {
			let index = arr.findIndex((e) => e[prop] === obj[prop]);
			// Check & Push to Array
			if (index === -1) {
				arr.push(obj);
			} else {
				arr.splice(index, 1, obj);
			}
		},
		removeFromArray: function (arr, obj, prop) {
			let index = arr.findIndex((e) => e[prop] === obj[prop]);
			// Check & Delete from Array
			if (index !== -1) {
				arr.splice(index, 1);
			}
		},
		truncate: function(value, limit) {
			if(value) {
				if(limit !== value.length - 1) {
					return value.substring(0, limit)+'...'
				} else {
					return value.substring(0, limit)
				}
			}
		},
		capitalizePromoName: function (s) {
			if (typeof s !== 'string') {
				return ''
			}
			else {
				return s.split('.').map(w => w.substring(0, 1).toUpperCase() + w.substring(1)).join('.')
			}
		},
		capitalizeFirstLetter: function (s) {
			if (typeof s !== 'string') {
				return ''
			}
			else {
				return s.split(' ').map(w => w.substring(0, 1).toUpperCase() + w.substring(1)).join(' ')
			}
		},
		toTitleCase: function (s) {
			if (!s) return ''

			return s.toLowerCase().split(' ').map(function (word) {
				return (word.charAt(0).toUpperCase() + word.slice(1));
			}).join(' ');
		},
		toDateMY: function(s) {
			if (s && typeof s === 'string') {
				if(s.charAt(0) == 'Q') {
					return s.split('_').join(' ');
				} else {
					// NOTE: Hard setting the date so as to avoid the February bug
					let date = new Date('01-01-01');
					date.setMonth(parseInt(s.split('_')[0]) - 1);
					
					return date.toLocaleString('en-US', { month: 'short' }) + " " + s.split('_')[1];
				}
			} else {
				return ''
			}
		},
		isAMExclusionActive: function() {
			return JSON.parse(localStorage.getItem("userDetails")).name.includes(process.env.VUE_APP_AM_EXCLUSION);
		}
	}
});
